<template>
    <header>
        <nav class="navbar navbar-light container-fluid ">
            <span class="navbar-brand text-light">
                <i class="bi-file-person"></i>&nbsp;
                <router-link class="navbar-brand text-light" to="/">In my pocket</router-link>
            </span>

        </nav>
    </header>
</template>

<script>

</script>
<style scoped>
    header {
        background-color: #1a73e8;
    }
</style>